// extracted by mini-css-extract-plugin
export var copyableItem = "_k-0";
export var underlined = "_k-1";